import { Avatar } from "primereact/avatar"
import { Button } from "primereact/button"
import { Divider } from "primereact/divider"
import { Menu } from "primereact/menu"
import { MultiSelect } from 'primereact/multiselect'
import { ProgressSpinner } from "primereact/progressspinner"
import React, { Fragment, useEffect, useRef, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { useNavigate } from "react-router-dom"
import dashboardImage from "../../assests/dashboard.svg"
import filterImage from "../../assests/filterImage.svg"
import BreadCrumbComp from "../../component/breadCrumb/breadCrump"
import CardComp from "../../component/card/cardComp"
import IconInputText from "../../component/iconInputText/iconInputText"
import PaginatorComp from "../../component/paginator/paginator"
import SelectButtonComp from "../../component/SelectButton/selectButtonComp"
import TableComponent from "../../component/Tables/tableComponent"
import { setDataAssetActiveTab } from "../../redux/dataAsset/dataAsset.action"
import { getdataAssets,getDataAssetsUserDetails} from "../../redux/dataAssets/dataAssets.action"
import { SET_FORM_VALUE, SET_FORM_VALUEOBJ } from "../../redux/home/home.type"
import { theme } from "../../theme/theme"
import { Container } from "../global/global.style"
import AddNewDataAssests from "./addNewDataAssests"
import { CardTitle, CardValue } from "./dataAssets.style"
import { getADLSAccount, getAssetOwner, getDataDomainSubdomain, getdataProducts, getRegion } from "../../redux/home/home.action"
import { Toast } from "primereact/toast"
import { PanelMenu } from 'primereact/panelmenu';
import { Badge } from "primereact/badge"
import { FaChevronDown, FaChevronUp } from "react-icons/fa"
import { panelDomainList } from "../../data/dataDomain/domainPanel"
import { userLevelRoleMapping } from "../../data/userAccess/userRoleMapping"
import { EllipsisTooltip } from "../../component/EllipsisHeader"
import { Tooltip } from "primereact/tooltip"

const INFOTEXT = [
  'Total number of data assets available.',
  'Execution-ready assets linked to scheduled pipelines, with data quality checks in place.',
  'Includes all configured data quality rules linked to total onboarded assets, not limited to only those currently active or executed.',
  'Total number of data quality rule executions across active assets as part of pipeline runs.',
  'Number of data quality rules that failed during execution on active assets as part of pipeline runs.',
  'Represents the percentage of successful rule executions during pipeline runs. Calculated as: (Passed Rules/ Total Executed Rules) * 100.',
]


function DataAssestsViewAll() {

  const { steppersData } = useSelector((state) => state.crumbs)
  const { apiData, formData } = useSelector((state) => state.dataAssets)
  const { home } = useSelector((state) => state)
  const [selectedSubDomainName, setSelectedSubDomainName] = useState([])
  const [searchVal, setSearchVal] = useState("")
  const [activateViewButton, setActivateViewButton] = useState("Grid View")
  const [whomDataButton, setWhomDataButton] = useState("All Data Assets")
  const [currentPage, setCurrentPage] = useState(1);
  const [tempDataassetsData, setTempDataAssetsData] = useState(apiData.dataAssestsList.data)
  const [initialDataAssetData, setInitialDataAssetData] = useState(apiData.dataAssestsList.data)
  const [dataAssetUserDetails, setDataAssetUserDetails] = useState(apiData.userDetails.data)
  const [canDisableNewAsset, setcanDisableNewAsset] = useState(true);
  const navigate = useNavigate()
  const cardsPerPage = 4;  // Number of cards per page
  const cardHeight = 188
  const CardSectionHeight = (cardHeight - (40 + 28 + 5 + 10 + 3)) / 2
  const indexOfLastCard = currentPage * cardsPerPage;
  const indexOfFirstCard = indexOfLastCard - cardsPerPage;
  const [updateIcon, setUpdateIcon] = useState("pi-sort-amount-down");
  const [qualityIcon, setQualityIcon] = useState("pi-sort-amount-down");
  const [enableNewDataAssests, setEnableNewDataAssests] = useState(false)
  const dispatch = useDispatch()
  const menuLeft = useRef(null);
  const [uniqueRegions, setUniqueRegions] = useState([])
  const [selectedRegions, setSelectedRegions] = useState(null);
  // State to track the expanded panel
  const [expandedKeys, setExpandedKeys] = useState({});
  const [selectedSubItem, setSelectedSubItem] = useState(null); // Track selected sub-item
  const [activeSubitem, setActiveSubitem] = useState([]);
  const [filterEnable, setFilterEnable] = useState(false)

  const itemRenderer = (item, options) => (
    <div style={{ paddingLeft: "5px", height: "30px", lineHeight: "30px" }} className="cursor-pointer" onClick={options.onClick}>
      <span className={`${item.icon} text-primary`} />
      <span className={`mx-2 ${item.items && 'font-semibold'}`}>{item.label}</span>
      <span style={{ float: 'right', marginRight: '10px' }}>
        {expandedKeys[item.label] ? (
          <FaChevronUp />
        ) : (
          <FaChevronDown />
        )}
      </span>
      {/* {item.badge && <Badge className="ml-auto" value={item.badge} />}
      {item.shortcut && <span className="ml-auto border-1 surface-border border-round surface-100 text-xs p-1">{item.shortcut}</span>} */}
    </div>
  );




  const items = [
    {
      label: 'Options',
      items: [
        {
          label: "Clear Filter",
          command: () => {
            setFilterEnable(false)
          }
        },
        {
          label: 'Last Update',
          icon: 'pi pi-sort-amount-down',
          command: () => {
            setFilterEnable(true)
            getUpdateIcon("pi-sort-amount-down")
          }
        },
        {

          label: 'Last Update',
          icon: 'pi pi-sort-amount-up',
          command: () => {
            setFilterEnable(true)
            getUpdateIcon("pi-sort-amount-up")
          }
        },
        {
          label: 'Quality Score',
          icon: 'pi pi-sort-amount-down',
          command: () => {
            setFilterEnable(true)
            getQualityIcon("pi-sort-amount-down")
          }
        },
        {
          label: 'Quality Score',
          icon: 'pi pi-sort-amount-up',
          command: () => {
            setFilterEnable(true)
            getQualityIcon("pi-sort-amount-up")
          }
        },
      ]
    }
  ];
  const toast = useRef(null);

  const show = (status, message) => {
    if (status === undefined) {
      toast.current.show({
        severity: apiData.newDataAssest.status === "success" ? "success" : apiData.newDataAssest.status === "fail" ? "error" : 'info', summary: apiData.newDataAssest.status, detail: apiData.newDataAssest.data.message
      });

    } else {
      toast.current.show({
        severity: status === "success" ? "success" : status === "fail" ? "error" : 'info', summary: status, detail: message
      });
    }

  }
  const showLoadingMessage = () => {
    toast.current.show({
      severity: 'info', summary: "Note", detail: "The onboarding process may take up to 1-2 min.Please be patient while the newly asset become visible on the page."
      // apiData.newDataAssest.data 
    });
  };

  const getDomainList = () => {
    let domainList = []
    panelDomainList.map((val1) => {
      home.formData.domainSubDomainForm.options.map((val) => {
        if (val1.value === val.domain_name) {
          domainList.push({
            key: val.domain_name,
            label: val.domain_name,
            icon: 'pi pi-database',
            template: itemRenderer,
            items: val.subdomains.map((val2) => {
              return {
                id: val2.sub_domain_id,
                key: val2.sub_domain_name,
                label: val2.sub_domain_name,
                template: renderCustomSubitem,
                command: (e) => {
                  let tempItemp = []
                  let match = 0
                  if (selectedSubDomainName !== null) {
                    selectedSubDomainName.map((val) => {
                      if (val === e.item.label) {
                        match = 1
                      } else {
                        tempItemp.push(val)
                      }
                    }
                    )
                  }
                  if (match === 0) {
                    tempItemp.push(e.item.label)
                  }
                  setSelectedSubDomainName(tempItemp)
                }
              }
            })
          })
        }

      })
    })
    return domainList
  }
  const onPageChange = (e) => {
    setCurrentPage(e.page + 1);  // Pagination component is zero-based
  };
  const getPaginationCardData = () => {

    let tempDataassetsValue = null
    if (selectedSubDomainName.length > 0) {
      tempDataassetsValue = []
      // JSON.parse(JSON.stringify(apiData.dataAssestsList.data)).filter((val) => val.sub_domain === selectedSubDomainName)
      JSON.parse(JSON.stringify(apiData.dataAssestsList.data)).map((val) => {
        selectedSubDomainName.map((val1) => {
          if (val.sub_domain === val1) {
            tempDataassetsValue.push(val)
          }
        }
        )
      }
      )
    } else {
      tempDataassetsValue = JSON.parse(JSON.stringify(apiData.dataAssestsList.data))

    }
    console.log(tempDataassetsValue.length)
    let searchTempDataassetsValue = []
    if (searchVal === "") {
      searchTempDataassetsValue = JSON.parse(JSON.stringify(tempDataassetsValue))
    } else {
      searchTempDataassetsValue = tempDataassetsValue.filter((val) => val.data_asset_name.toLowerCase().includes(searchVal.toLowerCase()))

    }
    let filteredRegionData = []
    if (selectedRegions !== null) {
      const selectedRegionName = selectedRegions.map((x) => x.name)
      filteredRegionData = selectedRegions.length > 0 ? searchTempDataassetsValue.filter(item => selectedRegionName.includes(item.region)) : searchTempDataassetsValue
    } else {
      filteredRegionData = JSON.parse(JSON.stringify(searchTempDataassetsValue))
    }
    const sortedDataDesc = filteredRegionData.sort((a, b) => new Date(b.created_date) - new Date(a.created_date));
    console.log(sortedDataDesc)
    setTempDataAssetsData(sortedDataDesc)
  }
  const getSortedData = () => {
    let tempData = JSON.parse(JSON.stringify(tempDataassetsData))
    console.log(tempData)
    let sortedDataDesc = []
    if (filterEnable) {
      if (whomDataButton === "All Data Assets") {
        sortedDataDesc = JSON.parse(JSON.stringify(tempDataassetsData))
        return sortedDataDesc
      } else if (whomDataButton === "My Data Assets") {
        let tempsortedDataDesc = JSON.parse(JSON.stringify(tempDataassetsData))
        sortedDataDesc = tempsortedDataDesc.filter((val) =>  val.created_by  === localStorage.getItem("userId"))
      }

    } else {
      if (whomDataButton === "All Data Assets") {
        sortedDataDesc = tempData.sort((a, b) => new Date(b.created_date) - new Date(a.created_date));
        return sortedDataDesc
      } else if (whomDataButton === "My Data Assets") {
        let tempsortedDataDesc = tempData.sort((a, b) => new Date(b.created_date) - new Date(a.created_date));
        sortedDataDesc = tempsortedDataDesc.filter((val) =>   val.created_by  === localStorage.getItem("userId"))
      }

    }
    return sortedDataDesc
  }
  const changeDetail = (e, type, value) => {
    switch (type) {
      case "text": {
        dispatch({
          type: SET_FORM_VALUE,
          payload: {
            formField: e.target.name,
            value: e.target.value
          }
        })
        break
      }
      case "dropdown": {
        dispatch({
          type: SET_FORM_VALUE,
          payload: {
            formField: e.target.name,
            value: value
          }
        })
        dispatch({
          type: SET_FORM_VALUEOBJ,
          payload: {
            formField: e.target.name,
            valueAsObj: e.target.value
          }
        })
        break
      }
      case "file": {
        dispatch({
          type: SET_FORM_VALUE,
          payload: {
            formField: e.target.name,
            value: e.target.files[0]
          }
        })
        break
      }
      default: console.log("No type present : " + type)
    }
  }
  const getQualityIcon = (icon) => {
    let tempData = JSON.parse(JSON.stringify(tempDataassetsData))
    let stempData = []
    if (icon === "pi-sort-amount-down") {
      stempData = tempData.sort((obj1, obj2) => obj2.metrics.score - obj1.metrics.score);
    } else if (icon === "pi-sort-amount-up") {
      stempData = tempData.sort((obj1, obj2) => obj1.metrics.score - obj2.metrics.score)
    }
    console.log(stempData)
    setTempDataAssetsData(stempData)

  }
  const getUpdateIcon = (icon) => {
    let tempData = JSON.parse(JSON.stringify(tempDataassetsData))
    if (icon === "pi-sort-amount-down") {
      tempData.sort((obj1, obj2) => obj2.last_modified - obj1.last_modified);
      setUpdateIcon("pi-sort-amount-up")
    } else if (icon === "pi-sort-amount-up") {
      tempData.sort((obj1, obj2) => obj1.last_modified - obj2.last_modified);
      setUpdateIcon("pi-sort-amount-down")
    }
    setTempDataAssetsData(tempData)

  }
  const nameBodyTemplate = (rowData) => {
    return (
      <span
        style={{ color: 'blue', cursor: 'pointer',display: 'inline-block',
          maxWidth: '250px',       
          wordWrap: 'break-word',
          whiteSpace: 'normal'  
   }}
        onClick={() => {
          navigate(`/dataAsset/${rowData.data_asset_id}`)
        }}
      >
        {rowData.data_asset_name}
      </span>
    );
  };
  const descriptionBodyTemplate = (rowData) => {
    return (
      <span
        style={{
          display: 'inline-block',
          maxWidth: '250px',
          wordWrap: 'break-word',
          whiteSpace: 'normal'
        }}
      >
        {rowData.description}
      </span>
    );
  };
  
  const OpenLinkButton = () => {
    window.open(process.env.REACT_APP_API_POWERBIDASHBOARD, '_blank');
  };
  const getTableColumns = () => {
    return [
      { field: "data_asset_name", header: "Assets Name",sortable:true, body: nameBodyTemplate },
      { field: "description", header: "Description" , body: descriptionBodyTemplate},
      { field: "metrics.dq_rules_count",sortable:true, header: "No of DQ Rules" },
      { field: "metrics.score", header: "Quality Score",sortable:true },
      { field: "metrics.last_updated", header: "Last Updated" },
      {
        field: "created_date", 
        header: "Created Date", 
        body: (val) => {
          return (val.created_date === undefined || val.created_date === null || val.created_date === "")
            ? ""  
            : new Date(val.created_date).toISOString().split('T')[0];
        }}
    ]
  }

  const cardTitle = (title, index) => {
    return (
      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
        <CardTitle>{title}</CardTitle>
        <div style={{ marginRight: '10px' }}>
          
        <Tooltip target=".custom-target-icon" />
          <i className="custom-target-icon pi pi-info-circle p-text-secondary p-overlay-badge"
            data-pr-tooltip={INFOTEXT[index]}
            data-pr-position="top"
            style={{ cursor: 'pointer', color: theme.colors.primary }}
          >
          </i>
        </div>
      </div>
    )
  }

  // Handle subitem click
  const onSubitemClick = (id) => {
    let tempItemp = []
    let match = 0
    if (activeSubitem !== null) {
      activeSubitem.map((val) => {
        if (val === id) {
          match = 1
        } else {
          tempItemp.push(val)
        }
      }
      )
    }
    if (match === 0) {
      tempItemp.push(id)
    }
    setActiveSubitem(tempItemp)

    // if (activeSubitem === null) {

    //   setActiveSubitem([id])
    // } else {
    //   setActiveSubitem((prev) => [
    //     ...prev,          // Spread the previous array
    //     id,     // Add the new item
    //   ]);
    // }

  };
  const renderCustomSubitem = (item) => {

    let isHighlight = activeSubitem?.filter((val) => val === item.id)[0] ? true : false
    return (
      <div
        className={`p-menuitem-link ${isHighlight ? 'highlighted' : ''}`}
        onClick={() => onSubitemClick(item.id)}
      >
        <span className={item.icon}></span>
        {item.label}
      </div>
    );
  };
  useEffect(() => {
    getPaginationCardData()
  }, [searchVal, selectedSubDomainName, selectedRegions])
  useEffect(() => {
    dispatch(getDataAssetsUserDetails());
    dispatch(getdataAssets())
    dispatch(getdataProducts())
    dispatch(getDataDomainSubdomain())
    dispatch(getRegion())
    dispatch(getADLSAccount())
    dispatch(getAssetOwner())

  }, [])
  useEffect(() => {
    setTempDataAssetsData(apiData.dataAssestsList.data)
    setInitialDataAssetData(apiData.dataAssestsList.data)
    // setting up region data with format that will work with multiselect
    const uniqueRegions = [...new Set(apiData.dataAssestsList.data.map(item => item.region))].map(region => ({ name: region }));
    setUniqueRegions(uniqueRegions)
  }, [apiData.dataAssestsList.data])

  useEffect(() => {
    setDataAssetUserDetails(apiData.userDetails.data)
  }, [apiData.userDetails.data])

  useEffect(() => {
    const roleId = dataAssetUserDetails?.user_details?.role_id;
    if (roleId) {
      const permission = userLevelRoleMapping[roleId]?.buttons?.["Onboard New Data Asset"] == true ? false : true;
      setcanDisableNewAsset(permission); 
    }
  }, [dataAssetUserDetails]);
  
  
  // useEffect(() => {

  //   let tempDataassetsValue = JSON.parse(JSON.stringify(tempDataassetsData))
  //   if (selectedRegions !== null) {
  //     const selectedRegionName = selectedRegions.map((x) => x.name)
  //     const filteredData = selectedRegions.length > 0 ? tempDataassetsValue.filter(item => selectedRegionName.includes(item.region)) : tempDataassetsValue

  //     setTempDataAssetsData(filteredData)
  //   }
  // }, [selectedRegions])

  return <Fragment>
    <BreadCrumbComp items={steppersData.dataAssetsSteps} />
    {apiData.dataAssestsList.loading && apiData.newDataAssest.status === "idle"
      ?
      <div style={{ width: "100%", textAlign: "center", lineHeight: window.innerHeight + "px", verticalAlign: "middle" }}><ProgressSpinner /></div> :

      <Container>
        <div className="grid" style={{ marginBottom: "4px" }}>
          <div className="col-2" >
            <h3 style={{ margin: "0px", marginTop: "10px" }}> Data Assets</h3>
          </div>
          <div className="col-10" style={{ textAlign: "right" }}>
            <div style={{ width: "300px", display: "inline-block", marginRight: "5px" }}>
              <IconInputText iconPosition="left" style={{ width: "100%", height: "40px", margin: "0px" }} value={searchVal} onChange={(e) => { setSearchVal(e.target.value) }} iconName="pi-search" placeholderName="Search for Data Assets" />
            </div>
            <Button
              type="button"
              label="View Dashboard"
              icon={<img style={{ margin: "0px 2px" }} src={dashboardImage} />}
              outlined onClick={OpenLinkButton}
              style={{ marginRight: "5px", height: "40px" }}
              iconPos="right"
              className="my-button"
              disabled={!(initialDataAssetData && initialDataAssetData?.length > 0)}
            />
            <Button style={{ marginRight: "8px", width: "43px", height: "40px" }} icon="pi pi-refresh" onClick={() => {
              dispatch(getdataAssets())
            }} outlined />

          </div>
        </div>
        <div className="grid" >
          {/* <CardWrapper> */}
          {/* {apiData.dataAssestsDetails.data.map((val, index) => {
            return  */}
            <div className="col-2">
              <CardComp style={{textAlign: "center", margin: "0px" }} title={cardTitle("Total Assets",0)}>
                <CardValue style={{ padding: "0 10px 10px 10px", color: apiData.dataAssestsDetails.data[0].color, display: 'flex' }}>{apiData.dataAssestsDetails.data[0].value}</CardValue>
              </CardComp>
            </div>
            <div className="col-2">
              <CardComp style={{textAlign: "center", margin: "0px" }} title={cardTitle("Total Quality Rules",2)}>
                <CardValue style={{ padding: "0 10px 10px 10px", color: apiData.dataAssestsDetails.data[2].color, display: 'flex' }}>{apiData.dataAssestsDetails.data[2].value}</CardValue>
              </CardComp>
            </div>
            <div className="col-2">
              <CardComp style={{textAlign: "center", margin: "0px" }} title={cardTitle("Active Assets",1)}>
                <CardValue style={{ padding: "0 10px 10px 10px", color: apiData.dataAssestsDetails.data[1].color, display: 'flex' }}>{apiData.dataAssestsDetails.data[1].value}</CardValue>
              </CardComp>
            </div>
            <div className="col-2">
              <CardComp style={{textAlign: "center", margin: "0px" }} title={cardTitle("Active Rules Executed",3)}>
                <CardValue style={{ padding: "0 10px 10px 10px", color: apiData.dataAssestsDetails.data[3].color, display: 'flex' }}>{apiData.dataAssestsDetails.data[3].value}</CardValue>
              </CardComp>
            </div>
            <div className="col-2">
              <CardComp style={{textAlign: "center", margin: "0px" }} title={cardTitle("Active Rules Failed",4)}>
                <CardValue style={{ padding: "0 10px 10px 10px", color: apiData.dataAssestsDetails.data[4].color, display: 'flex' }}>{apiData.dataAssestsDetails.data[4].value}</CardValue>
              </CardComp>
            </div>
            <div className="col-2">
              <CardComp style={{textAlign: "center", margin: "0px" }} title={cardTitle("Quality score",5)}>
                <CardValue style={{ padding: "0 10px 10px 10px", color: apiData.dataAssestsDetails.data[5].color, display: 'flex' }}>{apiData.dataAssestsDetails.data[5].value}</CardValue>
              </CardComp>
            </div>
          {/* })} */}
        </div>
        <div className="grid" style={{ margin: "0", height: "540px" }}>
          <div className="col-3" style={{ height: "100%" }}>

            <div style={{ height: "100%", backgroundColor: "white", marginTop: "5px", padding: "5px" }}>
              <div className="grid">
                <div className="col-5">
                  <Button style={{ height: "40px", marginBottom: "10px" }} outlined label="Clear Filter" onClick={() => {
                    setActiveSubitem(null)
                    setSelectedSubDomainName([])
                  }} />
                </div>
                <div className="col-7" style={{ textAlign: "right" }}>
                  <MultiSelect style={{ height: "40px", marginBottom: "10px", width: "150px" }} value={selectedRegions} onChange={(e) => setSelectedRegions(e.value)} options={uniqueRegions} optionLabel="name"
                    placeholder="Select Clusters" />
                </div>
              </div>
              <PanelMenu multiple style={{ height: "100%" }}
                onExpandedKeysChange={setExpandedKeys}
                expandedKeys={expandedKeys}
                model={getDomainList()}
                // Customize rendering of sub-items
                //  itemTemplate={renderCustomSubitem}
                className="w-full" />
            </div>
          </div>
          <div className="col-9" style={{ height: "100%" }}>
            <div className="grid" style={{ backgroundColor: "white", marginTop: "5px", width: "100%" }}>
              <div className="col-4" style={{ paddingBottom: "0px" }}>
                <SelectButtonComp style={{ height: "40px" }} value={{ name: whomDataButton }} onChange={(e) => {setWhomDataButton(e.value.name) ; setCurrentPage(1)}} optionLabel="name" options={[
                  { name: "My Data Assets" },
                  { name: "All Data Assets" },
                ]} />
                {/* <Button type="button" label="My Data Assests" outlined={whomDataButton === "My Data Assests" ? false : true} onClick={() => setWhomDataButton("My Data Assests")} style={{ marginRight: "10px" }} iconPos="right" />
            <Button type="button" label="All Data Assests" outlined={whomDataButton === "All Data Assests" ? false : true} onClick={() => setWhomDataButton("All Data Assests")} iconPos="right" /> */}
              </div>
              <div className="col-8" style={{ display: "flex", gap: "5px", justifyContent: "end" }}>
                {/* adding a multiselect where the  regions are extracted from the data*/}

                <div style={{ width: "192px", height: "40px" }}><SelectButtonComp style={{ width: "300px", height: "40px" }} value={{ name: activateViewButton }} onChange={(e) => setActivateViewButton(e.value.name)} optionLabel="name" options={[
                  { name: "Grid View" },
                  { name: "Table View" },
                ]} />  </div>
                <Menu model={items} popup ref={menuLeft} id="popup_menu_left" />
                <Button type="button" label="Onboard New Asset" disabled={canDisableNewAsset} icon="pi pi-plus-circle" iconPos="right" style={{ height: "40px" }} onClick={() => { setEnableNewDataAssests(true) }} />
                <img className="handCursor" style={{}} src={filterImage} alt="icon" width="36" height="40" onClick={(event) => menuLeft.current.toggle(event)} aria-controls="popup_menu_left" />
              </div>
            </div>
            <div className="grid" style={{ backgroundColor: "white", marginTop: "10px", width: "100%" }}>
              {activateViewButton === "Grid View" ?

                getSortedData().slice(indexOfFirstCard, indexOfLastCard).map((val) => {
                  return <div
                    className="col-6">
                     
                    <CardComp
                      className="handCursor"
                      onClick={() => navigate(`/dataAsset/${val.data_asset_id}`)}
                      style={{ border: "1px solid #E0E4FF", fontSize: "15pt", margin: "10px", marginRight: '20px', height: cardHeight + "px", boxShadow: " 0 4px 6px rgba(0, 0, 0, 0.1), 0 2px 4px rgba(0, 0, 0, 0.2)" }}
                      title={<div style={{borderBottom: "1px solid #E0E4FF",position:'relative'}}>

                   
           
                           
                          <EllipsisTooltip icon="pi pi-database" text={val.data_asset_name} maxWidth={'100%'} />
                          {/* {val.data_asset_name}{val.created_at === undefined || val.created_at === null || val.created_at === "" ? "" : new Date().getFullYear() === new Date(val.created_at).getFullYear() &&
                          new Date().getMonth() === new Date(val.created_at).getMonth() &&
                          new Date().getDate() === new Date(val.created_at).getDate() ? <span style={{ marginLeft: "10px", verticalAlign: "middle", fontSize: "10px" }}>[New]</span> : ""} */}
                          
                      
                      
                      </div>}
                    >
                      <div style={{ padding: "0 10px", height: (cardHeight - (cardHeight / 1.6)) + "px", overflowX: "visible", overflowY: "hidden", whiteSpace: "normal", fontSize: "9pt", borderBottom: "1px solid #e3d8d8" }}>
                     
                        <span className="dataAssetsDescription" >{val.description}</span>
                      </div>
                      <div style={{ padding: "0px", margin: " 0px" }} className="grid">
                        <div style={{ textAlign: "center",fontSize: "9pt", borderRight: "1px solid #e3d8d8",display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'space-around' }} className="col-3">
                          <div>
                            No.of DQ Rules
                          </div>
                          <div style={{ marginTop: "10px", fontWeight: "bold" }}>{val.metrics.dq_rules_count}</div>
                        </div>
                        <div  style={{ textAlign: "center",fontSize: "9pt", borderRight: "1px solid #e3d8d8",display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'space-around' }} className="col-3">
                          <div>
                            Quality Score
                          </div>
                          <div style={{ marginTop: "10px", fontWeight: "bold", color: parseFloat(val.metrics.score) > 95 ? theme.colors.success : parseFloat(val.metrics.score) < 91 ? theme.colors.fail : theme.colors.yellow }}>{val.metrics.score}</div>
                        </div>
                        <div className="col-3" style={{ textAlign: "center",fontSize: "9pt", borderRight: "1px solid #e3d8d8",display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'space-around' }}>
                          <div>
                            Updated
                          </div>
                          <div style={{ marginTop: "10px", fontWeight: "bold" }}>{val.metrics.last_updated}</div>
                        </div>
                        <div className="col-3"  style={{ textAlign: "center",fontSize: "9pt", borderRight: "1px solid #e3d8d8",display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'space-around' }}>
                          <div>
                            Created
                          </div>
                          <div style={{ marginTop: "10px", fontWeight: "bold" }}>
                            {val.created_date === undefined || val.created_date === null || val.created_date === "" ? "" : new Date(val.created_date).toISOString().split('T')[0]}
                          </div>
                        </div>
                      </div>
                    </CardComp>
                  </div>
                }) : <TableComponent scrollable scrollHeight="100%" checked={false} style={{ width: "100%", height: `${(window.innerHeight * 85) / 100}px`, }} tableData={getSortedData()} columns={getTableColumns()} />
              }
            </div>
            {activateViewButton === "Grid View" ? <PaginatorComp
              first={indexOfFirstCard}
              rows={cardsPerPage}
              totalRecords={getSortedData().length}
              onPageChange={onPageChange}
              title="Assets"
              style={{ display: "contents", backgroundColor: "transparent", marginTop: '20px' }}
            /> : null}
          </div>
        </div>

        {enableNewDataAssests ? <AddNewDataAssests showLoadingMessage={showLoadingMessage} show={show} changeDetail={changeDetail} onHide={() => { setEnableNewDataAssests(false) }} />
          : ""}
        <Toast ref={toast} />
        {/* {apiData.newDataAssest.status !== "idle" && apiData.newDataAssest.status !== "loading" ? show() : null} */}
      </Container>}


  </Fragment>
}
export default DataAssestsViewAll